export default __webpack_public_path__ + "static/media/planner.e3f5cf3c.jpeg";